<template>
    <div>
        <canvas ref="canvas"
                @mousedown="startDrawing"
                @mousemove="draw"
                @mouseup="stopDrawing"
                @mouseout="stopDrawing"
                @touchstart="startDrawing"
                @touchmove="draw"
                @touchend="stopDrawing"
                @touchcancel="stopDrawing">

        </canvas>
        <div class="row">
            <div class="col-12 col-sm-6">
                <button type="button" class="formSubmit" @click="clearCanvas">Borrar</button>
            </div>
            <div class="col-12 col-sm-6">
                <button :disabled="isSaving" type="button" class="formSubmit" @click="saveCanvas"> {{ isSaving ? 'Guardando...' : 'Guardar' }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isSaving: false,
            drawing: false,
            context: null,
            lastX: 0,
            lastY: 0
        };
    },
    methods: {
        startDrawing(e) {
            if(e.type === 'touchstart') {
                e = e.touches[0];
                this.lastX = e.clientX - e.target.getBoundingClientRect().left;
                this.lastY = e.clientY - e.target.getBoundingClientRect().top;
            } else {
                this.lastX = e.offsetX;
                this.lastY = e.offsetY;
            }
            this.drawing = true;
            //console.log(this.lastX, this.lastY);
        },
        draw(e) {
            if (!this.drawing) return;
            let offsetX, offsetY;
            if(e.type === 'touchmove') {
                e.preventDefault();
                e = e.touches[0];
                offsetX = e.clientX - e.target.getBoundingClientRect().left;
                offsetY = e.clientY - e.target.getBoundingClientRect().top;
            } else {
                offsetX = e.offsetX;
                offsetY = e.offsetY;
            }
            this.context.beginPath();
            this.context.moveTo(this.lastX, this.lastY);
            this.context.lineTo(offsetX, offsetY);
            this.context.stroke();
            [this.lastX, this.lastY] = [offsetX, offsetY];
        },
        stopDrawing() {
            this.drawing = false;
        },
        clearCanvas() {
            this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
        },
        saveCanvas() {
            this.isSaving = true;
            let dataUrl = this.$refs.canvas.toDataURL(); // Esto convierte el contenido del canvas a una imagen en formato base64
            // Emitir un evento con la imagen en base64 como payload
            this.$emit('save-image', dataUrl);
        }
    },
    mounted() {
        this.context = this.$refs.canvas.getContext('2d');
        this.context.canvas.width = this.$refs.canvas.parentElement.offsetWidth;
        this.context.canvas.height = 200;
        this.context.strokeStyle = "#000";
        this.context.lineJoin = 'round';
        this.context.lineCap = 'round';
        this.context.lineWidth = 2;
    }
};
</script>

<style scoped>
canvas {
    border: 1px solid black;
}
</style>
